import { cn } from '@shared/lib/cn'

import styles from './contact-block.module.scss'

type GenericContact = {
  label: string
  settings?: Record<string, unknown>
  type?: string
  url?: string
  className?: string
}

function ContactBlockItem ({ contact }: { contact: GenericContact }) {
  if (!contact?.type) {
    return null
  }

  const className = cn(styles.root__list__item, contact?.className)

  if (contact?.url) {
    return <a className={className} href={contact.url} {...(contact?.settings)}>{contact.label}</a>
  }
  else {
    return <span className={className} {...contact?.settings}>{contact.label}</span>
  }
}

export type ContactBlockProps = {
  title: string
  footer?: string
  contacts: GenericContact[]
}
export default function ContactBlock ({ title, footer, contacts = [] }: ContactBlockProps) {
  return <div className={styles.root}>
    <h3 className={styles.root__title}>{title}</h3>
    <div className={styles.root__list}>
      {contacts.map(contact =>
        <ContactBlockItem contact={contact} />
      )}
    </div>
    { footer && <span className={styles.root__footer}>{footer}</span> }
  </div>
}